import { Routes, Route, useLocation } from "react-router-dom";
import { SiteMetadataProvider } from "./context/SiteMetadataContext";
import { useAnalytics } from "@/hooks/useAnalytics";
import Navbar from "./components/Header/Navbar";
import Footer from "./components/Footer";
import LayoutManager from "./layouts/utils/LayoutManager";
import Transition from "./components/Transition";
import ScrollToTop from "./components/ScrollToTop";
import { AppLayout, MainContent } from "./layouts/Styled.Layout";
import Home from "./pages/home";
import About from "./pages/about";
import Resources from "./pages/resources";
import Newsletter from "./pages/newsletter";
import Contact from "./pages/contact";
import Privacy from "./pages/privacy";
import ArticleArchivePage from "./pages/articles";
import ArticleSinglePage from "./pages/articles/[slug]";
import ConfirmSubscription from "./pages/confirm-subscription";

console.log("VITE_SERVERLESS_BASE =", import.meta.env.VITE_SERVERLESS_BASE);

function App() {
  const location = useLocation();
  useAnalytics(); // This handles all page tracking
  return (
    <SiteMetadataProvider>
      <AppLayout>
        <Navbar />
        <ScrollToTop />
        <MainContent>
          <Transition>
            <Routes location={location} key={location.pathname}>
              {/* PrimaryLayout */}
              <Route
                path="/"
                element={
                  <LayoutManager
                    layout="primary"
                    showEmailSignup={false}
                    heroProps={{
                      title: "The counterintuitive way for designers to win...",
                    }}
                  >
                    <Home />
                  </LayoutManager>
                }
              />
              <Route
                path="/about"
                element={
                  <LayoutManager
                    layout="primary"
                    showEmailSignup={true}
                    heroProps={{ title: "About" }}
                  >
                    <About />
                  </LayoutManager>
                }
              />
              <Route
                path="/resources"
                element={
                  <LayoutManager
                    layout="primary"
                    showEmailSignup={true}
                    heroProps={{ title: "Resources" }}
                  >
                    <Resources />
                  </LayoutManager>
                }
              />
              <Route
                path="/newsletter"
                element={
                  <LayoutManager
                    layout="primary"
                    showEmailSignup={true}
                    heroProps={{ title: "Newsletter" }}
                  >
                    <Newsletter />
                  </LayoutManager>
                }
              />
              {/* Articles archive - its own layout */}
              <Route
                path="/articles"
                element={
                  <LayoutManager
                    layout="articleArchive"
                    showEmailSignup={true}
                    heroProps={{ title: "Articles" }}
                  >
                    <ArticleArchivePage />
                  </LayoutManager>
                }
              />
              <Route path="/articles/:slug" element={<ArticleSinglePage />} />
              <Route
                path="/contact"
                element={
                  <LayoutManager
                    layout="primary"
                    showEmailSignup={false}
                    heroProps={{ title: "Contact" }}
                  >
                    <Contact />
                  </LayoutManager>
                }
              />
              <Route
                path="/privacy"
                element={
                  <LayoutManager
                    layout="primary"
                    showEmailSignup={false}
                    heroProps={{ title: "Privacy Policy" }}
                  >
                    <Privacy />
                  </LayoutManager>
                }
              />
              <Route
                path="/confirm-subscription"
                element={
                  <LayoutManager
                    layout="primary"
                    showEmailSignup={false}
                    heroProps={{ title: "Way To Go!" }}
                  >
                    <ConfirmSubscription />
                  </LayoutManager>
                }
              />
            </Routes>
          </Transition>
        </MainContent>
        <Footer />
      </AppLayout>
    </SiteMetadataProvider>
  );
}

export default App;
